import BigNumber from 'bignumber.js';

import type { BigNumber as RawBigNumber } from '@app/types/BigNumber';

type BigNumberLike =
  | BigNumber
  | RawBigNumber
  | string
  | number
  | null
  | undefined;

export const bigNumberToString = (
  value?: BigNumberLike,
  decimals: number = 2
): string => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return new BigNumber(value).toFixed(decimals);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyValue: any = value;

  if (typeof anyValue.toString === 'function') {
    return new BigNumber(anyValue.toString()).toFixed(0);
  }

  const raw = value as RawBigNumber;
  const sign = raw.s < 0 ? '-' : '';
  const digits = raw.c.join('');
  const exponent = raw.e;

  const composed = `${sign}${digits}e${exponent}`;
  return new BigNumber(composed).toFixed(0);
};
